import React from "react";
import { Link } from "react-router-dom";
import { getLocalMatchTime } from "../../utils/matchTimeConverter";

const IPLMatchCardCompleted = ({ match }) => {
  // =========================
  // GOAL SCORERS
  // =========================

  const homeGoals =
    match?.goalscorer?.filter(
      (goal) => goal?.home_scorer
    ) || [];

  const awayGoals =
    match?.goalscorer?.filter(
      (goal) => goal?.away_scorer
    ) || [];
  const result =
    getLocalMatchTime({
      country: match?.country_name,
      matchDate: match?.match_date,
      matchTime: match?.match_time,
    });
  return (
    <Link to={`/match/${match?.match_id}`}>
      <div className="relative overflow-hidden rounded-2xl cursor-pointer group transition-all duration-300">

        {/* Card */}
        <div className="relative bg-white dark:bg-[#121212] border border-gray-200 dark:border-gray-700 rounded-2xl overflow-hidden shadow-md group-hover:shadow-xl transition-all">

          {/* Hover glow */}
          <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-br from-blue-500/10 via-transparent to-green-500/10 pointer-events-none" />

          {/* Top gradient */}
          <div className="h-1 w-full bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500" />

          {/* League Logo */}
          <div className="absolute top-3 right-3 z-10">
            <div className="w-10 h-10 rounded-xl bg-white dark:bg-[#1e1e1e] border border-gray-300 dark:border-gray-600 shadow flex items-center justify-center overflow-hidden">

              <img
                src={match?.league_logo}
                alt={match?.league_name}
                className="w-full h-full object-contain"
              />

            </div>
          </div>

          <div className="p-4">

            {/* League Title */}
            <div className="text-center mb-3">

              <h3 className="text-base md:text-lg font-semibold text-gray-900 dark:text-white">
                {match?.league_name}
              </h3>

              <div className="flex items-center justify-center gap-2 mt-1">

                <div className="h-px w-8 bg-gradient-to-r from-transparent to-blue-500" />

                <span className="text-xs font-semibold text-blue-500">
                  {match?.league_year}
                </span>

                <div className="h-px w-8 bg-gradient-to-l from-transparent to-blue-500" />

              </div>

            </div>

            {/* Match Info */}
            <div className="flex items-center justify-between mb-3">

              <span className="text-xs font-semibold px-3 py-1 rounded-full border border-blue-500/30 text-blue-500 bg-blue-500/10">
                ⚽ Football
              </span>

              <span className="text-xs text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-800 px-3 py-1 rounded-full">
                Round {match?.match_round}
              </span>

            </div>

            {/* Match Score */}
            <div className="py-3">

              <div className="flex items-center justify-center gap-3">

                {/* Home Team */}
                <div className="flex items-center gap-3">

                  <div className="flex flex-col items-center gap-1">

                    <div className="w-12 h-12 md:w-14 md:h-14 p-2 bg-white dark:bg-[#1e1e1e] border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden">

                      <img
                        src={match?.team_home_badge}
                        alt={match?.match_hometeam_name}
                        className="w-full h-full object-contain"
                      />

                    </div>

                    <span className="text-xs text-center text-gray-700 dark:text-gray-300 max-w-[80px]">
                      {match?.match_hometeam_name}
                    </span>

                  </div>

                  <span className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
                    {match?.match_hometeam_score || 0}
                  </span>

                </div>

                {/* FT */}
                <div className="flex flex-col items-center px-2">

                  <span className="text-lg md:text-2xl text-gray-400 font-bold">
                    -
                  </span>

                  <span className="mt-1 bg-green-500/20 text-green-500 border border-green-500/30 text-[10px] px-2 py-0.5 rounded-full font-bold">
                    FT
                  </span>

                </div>

                {/* Away Team */}
                <div className="flex items-center gap-3">

                  <span className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
                    {match?.match_awayteam_score || 0}
                  </span>

                  <div className="flex flex-col items-center gap-1">

                    <div className="w-12 h-12 md:w-14 md:h-14 p-2 bg-white dark:bg-[#1e1e1e] border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden">

                      <img
                        src={match?.team_away_badge}
                        alt={match?.match_awayteam_name}
                        className="w-full h-full object-contain"
                      />

                    </div>

                    <span className="text-xs text-center text-gray-700 dark:text-gray-300 max-w-[80px]">
                      {match?.match_awayteam_name}
                    </span>

                  </div>

                </div>

              </div>

            </div>

            {/* Goals */}
            {(homeGoals?.length > 0 ||
              awayGoals?.length > 0) && (
                <div className="mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">

                  <div className="grid grid-cols-2 gap-2 text-xs">

                    {/* Home Goals */}
                    <div className="space-y-1 text-left text-gray-600 dark:text-gray-400">

                      {homeGoals?.map((goal, index) => (
                        <div
                          key={index}
                          className="flex items-center gap-1"
                        >
                          <span>⚽</span>

                          <span className="text-gray-900 dark:text-white font-medium truncate">
                            {goal?.home_scorer}
                          </span>

                          <span className="text-blue-500">
                            {goal?.time}'
                          </span>
                        </div>
                      ))}

                    </div>

                    {/* Away Goals */}
                    <div className="space-y-1 text-right text-gray-600 dark:text-gray-400">

                      {awayGoals?.map((goal, index) => (
                        <div
                          key={index}
                          className="flex items-center justify-end gap-1"
                        >
                          <span className="text-blue-500">
                            {goal?.time}'
                          </span>

                          <span className="text-gray-900 dark:text-white font-medium truncate">
                            {goal?.away_scorer}
                          </span>

                          <span>⚽</span>
                        </div>
                      ))}

                    </div>

                  </div>

                </div>
              )}

            {/* Footer */}
            <div className="mt-3 pt-2 border-t border-gray-200 dark:border-gray-700 text-center space-y-1">

              <p className="text-xs text-gray-500 dark:text-gray-400">
                📍 {match?.match_stadium}
              </p>

              <p className="text-xs text-gray-500 dark:text-gray-400">
                {result.localDate} • {result?.localTime}
              </p>

              <span className="inline-block bg-green-500/20 text-green-500 px-3 py-1 text-xs rounded-full font-semibold">
                Completed
                {/* {match?.match_status} */}
              </span>

            </div>

          </div>

          {/* Hover Arrow */}
          <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all">

            <div className="w-8 h-8 bg-blue-500/20 border border-blue-500/30 rounded-full flex items-center justify-center">
              ➜
            </div>

          </div>

        </div>
      </div>
    </Link>
  );
};

export default IPLMatchCardCompleted;